/**
 * wireLiveKeyRemaps — Apply DEFAULT_KEY_REMAPS to live input handlers (SPY-113).
 */

import {
  DEFAULT_KEY_REMAPS,
  listDefaultKeyRemaps
} from '../../domain/input/defaultKeyRemaps.js';

/**
 * @param {{
 *   keybindingManager?: { setRemaps?: Function },
 *   inputController?: { setRemaps?: Function },
 *   remaps?: Record<string, string>,
 *   globalObj?: object|null
 * }} [opts]
 */
export function wireLiveKeyRemaps({
  keybindingManager,
  inputController,
  remaps = { ...DEFAULT_KEY_REMAPS },
  globalObj = typeof window !== 'undefined' ? window : null
} = {}) {
  const state = { ...DEFAULT_KEY_REMAPS, ...remaps };

  function apply() {
    if (keybindingManager && typeof keybindingManager.setRemaps === 'function') {
      keybindingManager.setRemaps(state);
    }
    if (inputController && typeof inputController.setRemaps === 'function') {
      inputController.setRemaps(state);
    }
  }

  function set(partial = {}) {
    Object.assign(state, partial);
    apply();
    return get();
  }

  function get() {
    return { ...state };
  }

  function list() {
    return listDefaultKeyRemaps().map(({ action }) => ({
      action,
      key: state[action]
    }));
  }

  apply();

  const api = { get, set, list, reset: () => set({ ...DEFAULT_KEY_REMAPS }) };
  if (globalObj) globalObj.__debugKeyRemaps = api;
  return api;
}
